<template>
  <div class="customerBox casherBox">
    <div class="title">结账客户</div>
    <div class="customerBar">
      <div class="left"  >
        <div class="firstBar">{{ props.customer.name }} {{ props.customer.mobile }}</div>
        <div class="secondBar">
          <div class="someItem">本金 <text class="bigFinger">{{ (props.customer.storeAmount / 100) || 0 }}</text></div>
          <div class="someItem">赠金 <text class="bigFinger">{{ (props.customer.zengAmount / 100) || 0 }}</text></div>
          <div class="someItem">次卡 <text class="bigFinger">{{ props.customer.sum?.cika || 0 }}</text></div>
        </div>
      </div>
 
   
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

// 定义 props
const props = defineProps({
  customer: {
    type: Object,
    default: () => ({
      name: '',
      mobile: '',
      storeAmount: 0,
      zengAmount: 0,
      sum: {
        cika: 0
      }
    })
  }
})

 
 console.log(props.customer,'customer')
 
</script>

<style scoped>

.customerBox{
    background-color: white;
    border-radius: 2vw;
    margin-bottom: 5vw;
    padding: 3vw;
}
 
.casherBox .title{
  color:gray;
  font-size: 0.8rem;
  margin-bottom: 3vw;
}
.customerBox .customerBar{
  display: flex;
  justify-content: space-between;
}
.customerBar .secondBar{
  margin-top: 3vw;
  margin-bottom: 3vw;
  display: flex;
}
.customerBar .secondBar .someItem{
  margin-right: 4vw;
  font-weight: normal;
  color:gray;
 }
 .customerBar .secondBar .someItem .bigFinger{
   font-weight: bold;
   color:rgb(71, 71, 71);
 }
</style>